import HttpJson from './json'

const httpJson = HttpJson.create()

const ssoClient = {
  json: httpJson,
}

export default ssoClient
